import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import moment from 'moment';
import { selectPermissionsForUser } from '@authorisation/selectors';
import { usePageActions } from '@hooks/usePageActions';
import { useTitleUpdate } from '@hooks';
import { createDocument } from '@redux/documents/actions';
import { selectDocumentCreating } from '@redux/documents/reducers';
import { determineSourceTypeForNewContent } from '@utils';
import DocumentWizard from './Wizard';

const nowMoment = moment();

function NewDocument() {
  const dispatch = useDispatch();
  const creating = useSelector(selectDocumentCreating);
  const permissions = useSelector(selectPermissionsForUser);
  const { t } = useTranslation();
  const { setTitle } = usePageActions({ title: t('documents:Wizard.header') });
  useTitleUpdate(setTitle, 'documents:Wizard.header');

  const onCompleted = useCallback(
    formData => {
      if (formData) {
        const { content, details } = formData;

        const newDocument = {
          description: details.description,
          latest_version: { created: nowMoment.toISOString(), name: details.name },
          published: details.status === 'published',
          name: details.name,
          metadata: {
            language: details.language || 'en',
            source: determineSourceTypeForNewContent(permissions),
          },
          fileData: content.documents[0],
          audience_type: details.audience,
        };

        dispatch(createDocument(newDocument));
      }
    },
    [dispatch, permissions],
  );

  return <DocumentWizard submitting={creating} onCompleted={onCompleted} />;
}

export default NewDocument;
